import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  InputLabel
} from '@material-ui/core';
import classNames from 'classnames';

const LocationVerificationTextField = ({ classes, effectName, label, value, tooltip = false, success, error }) => {

  return (
    <div className={classNames(classes.container, effectName, error && classes.error, success && classes.success)}>
      <InputLabel shrink>{label}</InputLabel>
      <Typography
        variant='body1'
        noWrap
        className={classes.text}
        title={tooltip ? value : ''}
      >
        {value ?? ''}
      </Typography>
    </div>
  )
};

const styles = theme => ({
  container: {
    height: 48,
    width: 192,
    paddingLeft: 4,
    marginLeft: -4,
    borderRadius: 4,
    position: 'relative'
  },
  text: {
    marginTop: 4
  },
  success: {
    backgroundColor: '#b6f1a3'
  },
  error: {
    backgroundColor: '#ffc1c1'
  }
});

export default compose(
  withStyles(styles)
)(LocationVerificationTextField);